(function () {
  if (window.SawayCartDiscountApply) return;

  window.SawayCartDiscountApply = true;

  var storageKey = 'sawayCartDiscountStatus';
  var loadingWrappers = new WeakSet();

  function getCartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function normalizeCode(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function getNoteInput() {
    return document.querySelector('textarea[name="note"]');
  }

  function getNoteValue() {
    var noteInput = getNoteInput();
    return noteInput ? noteInput.value : '';
  }

  function setWrapperLoading(wrapper, isLoading) {
    if (!wrapper) return;

    var controls = wrapper.querySelectorAll('input[name="discount"], button[data-cart-discount-apply], button[data-cart-discount-remove]');

    if (isLoading) {
      loadingWrappers.add(wrapper);
    } else {
      loadingWrappers.delete(wrapper);
    }

    wrapper.toggleAttribute('xo-loading', isLoading);
    controls.forEach(function (control) {
      control.disabled = isLoading;
    });

    updateApplyButton(wrapper);
  }

  function setStatus(wrapper, type, message) {
    if (!wrapper) return;

    var status = wrapper.querySelector('[data-cart-discount-status]');
    if (!status) return;

    status.textContent = message || '';
    status.classList.remove('xo-cart-discount__status--success', 'xo-cart-discount__status--error');

    if (type) {
      status.classList.add('xo-cart-discount__status--' + type);
    }
  }

  function findDiscounts(cart) {
    var discounts = [];

    if (!cart) return discounts;

    [
      cart.cart_level_discount_applications,
      cart.discount_applications,
      cart.discount_codes,
    ].forEach(function (group) {
      if (Array.isArray(group)) {
        discounts = discounts.concat(group);
      }
    });

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (Array.isArray(item.discounts)) {
          discounts = discounts.concat(item.discounts);
        }

        if (Array.isArray(item.line_level_discount_allocations)) {
          item.line_level_discount_allocations.forEach(function (allocation) {
            if (allocation.discount_application) {
              discounts.push(allocation.discount_application);
            }
          });
        }
      });
    }

    return discounts;
  }

  function discountMatchesCode(discount, code) {
    var normalizedCode = normalizeCode(code);

    if (discount && discount.applicable === false) return false;

    return ['code', 'title', 'name'].some(function (key) {
      return normalizeCode(discount && discount[key]) === normalizedCode;
    });
  }

  function cartHasDiscountCode(cart, code) {
    return findDiscounts(cart).some(function (discount) {
      return discountMatchesCode(discount, code);
    });
  }

  function updateCartDiscount(discountCode) {
    return fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: discountCode,
        note: getNoteValue(),
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(response.statusText || 'Cart update failed');
      }

      return response.json();
    });
  }

  function saveStatusForReload(type, message) {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ type: type, message: message }));
    } catch (error) {
      return;
    }
  }

  function applyStoredStatus() {
    var savedStatus;

    try {
      savedStatus = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      sessionStorage.removeItem(storageKey);
    } catch (error) {
      savedStatus = null;
    }

    if (!savedStatus) return;

    document.querySelectorAll('xo-cart-discount').forEach(function (wrapper) {
      setStatus(wrapper, savedStatus.type, savedStatus.message);
    });
  }

  function refreshCartPage() {
    window.location.reload();
  }

  function isMiniCartWrapper(wrapper) {
    return !!(wrapper && wrapper.closest('xo-cart-mini'));
  }

  function updateCartSize(itemCount) {
    document.querySelectorAll('xo-cart-size').forEach(function (el) {
      el.textContent = itemCount;
    });
  }

  function replaceMiniCart(sectionHtml) {
    if (!sectionHtml) return false;

    var current = document.querySelector('xo-cart-mini#xo-cart-mini');
    if (!current) return false;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var next = parsed.querySelector('xo-cart-mini#xo-cart-mini');
    if (!next) return false;

    current.innerHTML = next.innerHTML;
    return true;
  }

  function syncXoCartStore(cart, sectionHtml) {
    if (!window.xoStore || typeof window.xoStore.set !== 'function') return;

    try {
      window.xoStore.set('xo-cart', function (currentState) {
        var sections = Object.assign({}, currentState && currentState.sections ? currentState.sections : {});
        if (sectionHtml) {
          sections['xo-cart-mini'] = sectionHtml;
        }

        return Object.assign({}, currentState, {
          size: cart && cart.item_count ? cart.item_count : 0,
          sections: sections,
          changeLineLoading: -1,
        });
      })('cart-discount/apply');
    } catch (error) {
      return;
    }
  }

  function refreshMiniCart(type, message) {
    var root = getCartRoot();

    return Promise.all([
      fetch(root + 'cart.js', { cache: 'no-store' }).then(function (response) {
        return response.json();
      }),
      fetch(root + '?sections=xo-cart-mini', { cache: 'no-store' }).then(function (response) {
        return response.json();
      }),
    ]).then(function (responses) {
      var cart = responses[0] || {};
      var sections = responses[1] || {};
      var sectionHtml = sections['xo-cart-mini'];

      updateCartSize(cart.item_count || 0);

      if (!replaceMiniCart(sectionHtml)) {
        refreshCartPage();
        return;
      }

      syncXoCartStore(cart, sectionHtml);
      updateApplyButtons();

      document.querySelectorAll('xo-cart-mini xo-cart-discount').forEach(function (wrapper) {
        setStatus(wrapper, type, message);
      });

      document.dispatchEvent(
        new CustomEvent('saway:cart-refreshed', {
          detail: { cart: cart, sections: sections },
        })
      );
    });
  }

  function updateApplyButton(wrapper) {
    if (!wrapper) return;

    var input = wrapper.querySelector('input[name="discount"]');
    var applyButton = wrapper.querySelector('[data-cart-discount-apply]');

    if (!input || !applyButton) return;

    applyButton.disabled = loadingWrappers.has(wrapper) || !input.value.trim();
  }

  function updateApplyButtons() {
    document.querySelectorAll('xo-cart-discount').forEach(updateApplyButton);
  }

  function handleApply(button) {
    var wrapper = button.closest('xo-cart-discount');
    var input = wrapper && wrapper.querySelector('input[name="discount"]');
    var code = input ? input.value.trim() : '';

    if (!code) {
      setStatus(wrapper, 'error', 'Lütfen bir kupon kodu girin.');
      return;
    }

    setWrapperLoading(wrapper, true);
    setStatus(wrapper, '', '');

    updateCartDiscount(code)
      .then(function (cart) {
        if (!cartHasDiscountCode(cart, code)) {
          setStatus(wrapper, 'error', 'Bu kupon bu sepet için geçerli değil.');
          return;
        }

        if (isMiniCartWrapper(wrapper)) {
          return refreshMiniCart('success', 'Kupon uygulandı.');
        }

        saveStatusForReload('success', 'Kupon uygulandı.');
        refreshCartPage();
      })
      .catch(function () {
        setStatus(wrapper, 'error', 'Kupon uygulanamadı. Lütfen tekrar deneyin.');
      })
      .finally(function () {
        setWrapperLoading(wrapper, false);
      });
  }

  function handleRemove(button) {
    var wrapper = button.closest('xo-cart-discount');
    var input = wrapper && wrapper.querySelector('input[name="discount"]');

    setWrapperLoading(wrapper, true);
    setStatus(wrapper, '', '');

    updateCartDiscount('')
      .then(function () {
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (isMiniCartWrapper(wrapper)) {
          return refreshMiniCart('success', 'Kupon kaldırıldı.');
        }

        saveStatusForReload('success', 'Kupon kaldırıldı.');
        refreshCartPage();
      })
      .catch(function () {
        setStatus(wrapper, 'error', 'Kupon kaldırılamadı. Lütfen tekrar deneyin.');
      })
      .finally(function () {
        setWrapperLoading(wrapper, false);
      });
  }

  document.addEventListener('click', function (event) {
    var applyButton = event.target.closest('[data-cart-discount-apply]');
    var removeButton = event.target.closest('[data-cart-discount-remove]');

    if (applyButton) {
      event.preventDefault();
      handleApply(applyButton);
    }

    if (removeButton) {
      event.preventDefault();
      handleRemove(removeButton);
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="discount"]')) {
      var wrapper = event.target.closest('xo-cart-discount');
      setStatus(wrapper, '', '');
      updateApplyButton(wrapper);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyStoredStatus();
      updateApplyButtons();
    });
  } else {
    applyStoredStatus();
    updateApplyButtons();
  }
})();
